function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars';
import { UI } from './../../utils';
/**
 * Scrollable component
 *
 * @author [malte-wessel](http://malte-wessel.github.io/react-custom-scrollbars/)
 */

var Scrollable =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Scrollable, _PureComponent);

  function Scrollable() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Scrollable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Scrollable)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      scrollTop: 0,
      scrollHeight: 0,
      clientHeight: 0
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleTouchStart", function (e) {
      _this.ts = e.touches[0].clientY;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleTouchMove", function (e) {
      if (!_this.props.isolate) {
        return true;
      }

      var scrollarea = _this.scrollable.parentNode;
      var te = e.changedTouches[0].clientY;
      var dir = _this.ts > te ? -1 : 1;
      var upTouch = dir === 1 && scrollarea.scrollTop === 0;
      var endTouch = dir === -1 && Math.floor(scrollarea.scrollTop) === scrollarea.scrollHeight - scrollarea.clientHeight;

      if (upTouch || endTouch) {
        e.preventDefault();
        _this.ts = te;
      }

      return true;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleScroll", function (e) {
      if (!_this.props.isolate) {
        return true;
      }

      var delta = e.deltaY || e.detail || e.wheelDelta;
      var scrollarea = _this.scrollable.parentNode;
      var dir = delta < 0 ? 1 : -1;
      var upTouch = dir === 1 && scrollarea.scrollTop === 0;
      var endTouch = dir === -1 && scrollarea.scrollTop === scrollarea.scrollHeight - scrollarea.clientHeight;

      if (upTouch || endTouch) {
        e.preventDefault();
      }

      return true;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleUpdate", function (values) {
      var scrollTop = values.scrollTop,
          scrollHeight = values.scrollHeight,
          clientHeight = values.clientHeight;

      _this.setState({
        scrollTop: scrollTop,
        scrollHeight: scrollHeight,
        clientHeight: clientHeight
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "hexToRgb", function (hex) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderTrack", function (_ref, dir) {
      var style = _ref.style,
          props = _objectWithoutProperties(_ref, ["style"]);

      var _this$props = _this.props,
          trackColor = _this$props.trackColor,
          trackOpacity = _this$props.trackOpacity,
          trackBorderRadius = _this$props.trackBorderRadius,
          trackWidth = _this$props.trackWidth;

      var hex = _this.hexToRgb(trackColor);

      var trackStyle = _objectSpread({
        background: "rgba(".concat(hex.r, ", ").concat(hex.g, ", ").concat(hex.b, ", ").concat(trackOpacity, ")"),
        borderRadius: "".concat(trackBorderRadius, "px"),
        zIndex: 14
      }, dir === 'vertical' ? {
        right: 4,
        top: 2,
        bottom: 2,
        width: "".concat(trackWidth, "px")
      } : {
        bottom: 4,
        left: 2,
        right: 2,
        height: "".concat(trackWidth, "px")
      });

      return React.createElement("div", _extends({
        style: _objectSpread({}, style, trackStyle)
      }, props));
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderThumb", function (_ref2) {
      var style = _ref2.style,
          scrollableProps = _objectWithoutProperties(_ref2, ["style"]);

      var _this$props2 = _this.props,
          thumbColor = _this$props2.thumbColor,
          thumbOpacity = _this$props2.thumbOpacity,
          thumbBorderRadius = _this$props2.thumbBorderRadius,
          thumbWidth = _this$props2.thumbWidth;
      var thumbStyle = {
        opacity: thumbOpacity,
        backgroundColor: UI.COLORS[thumbColor] || UI.THEME_COLORS[thumbColor],
        borderRadius: "".concat(thumbBorderRadius, "px"),
        width: "".concat(thumbWidth, "px")
      };
      return React.createElement("div", _extends({
        style: _objectSpread({}, style, thumbStyle)
      }, scrollableProps));
    });

    return _this;
  }

  _createClass(Scrollable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.scrollable.parentNode.addEventListener('touchstart', this.handleTouchStart, false);
      this.scrollable.parentNode.addEventListener('touchmove', this.handleTouchMove, false);
      this.scrollable.parentNode.addEventListener('wheel', this.handleScroll, false);
      this.scrollable.parentNode.addEventListener('scroll', this.handleScroll, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.scrollable.parentNode.removeEventListener('touchstart', this.handleTouchStart);
      this.scrollable.parentNode.removeEventListener('touchmove', this.handleTouchMove);
      this.scrollable.parentNode.removeEventListener('wheel', this.handleScroll);
      this.scrollable.parentNode.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: "calculateShadowOffset",
    value: function calculateShadowOffset() {
      var _this$state = this.state,
          scrollTop = _this$state.scrollTop,
          scrollHeight = _this$state.scrollHeight,
          clientHeight = _this$state.clientHeight;
      var shadowHeight = this.props.shadowHeight;
      var diffH = scrollHeight - clientHeight || 0;
      var a = scrollTop * 100 / (diffH <= 0 ? 1 : diffH);
      var b = shadowHeight * a / 100;
      return Math.floor(-shadowHeight + b);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          children = _this$props3.children,
          withShadow = _this$props3.withShadow,
          shadowHeight = _this$props3.shadowHeight,
          shadowColor = _this$props3.shadowColor,
          shadowOpacity = _this$props3.shadowOpacity,
          className = _this$props3.className,
          thumbColor = _this$props3.thumbColor,
          thumbOpacity = _this$props3.thumbOpacity,
          thumbBorderRadius = _this$props3.thumbBorderRadius,
          thumbWidth = _this$props3.thumbWidth,
          trackColor = _this$props3.trackColor,
          trackOpacity = _this$props3.trackOpacity,
          trackBorderRadius = _this$props3.trackBorderRadius,
          trackWidth = _this$props3.trackWidth,
          isolate = _this$props3.isolate,
          style = _this$props3.style,
          disabled = _this$props3.disabled,
          props = _objectWithoutProperties(_this$props3, ["children", "withShadow", "shadowHeight", "shadowColor", "shadowOpacity", "className", "thumbColor", "thumbOpacity", "thumbBorderRadius", "thumbWidth", "trackColor", "trackOpacity", "trackBorderRadius", "trackWidth", "isolate", "style", "disabled"]);

      if (disabled) return React.createElement("div", null, children);
      var _this$state2 = this.state,
          scrollHeight = _this$state2.scrollHeight,
          clientHeight = _this$state2.clientHeight;
      var shadowOffset = this.calculateShadowOffset();

      var containerStyle = _objectSpread({}, style, {
        position: 'relative'
      });

      var shadowTopStyle = {
        position: 'absolute',
        display: 'block',
        height: "".concat(shadowHeight, "px"),
        left: 0,
        right: 0,
        top: "-".concat(shadowHeight, "px"),
        opacity: shadowOpacity,
        backgroundImage: "linear-gradient(to bottom, ".concat(UI.COLORS[shadowColor], " 20%, rgba(255, 255, 255, 0) 100%)"),
        transform: "translateY(".concat(shadowHeight + shadowOffset, "px)"),
        zIndex: 10
      };
      var shadowBottomStyle = {
        position: 'absolute',
        display: 'block',
        height: "".concat(shadowHeight, "px"),
        left: 0,
        right: 0,
        bottom: 0,
        opacity: shadowOpacity,
        backgroundImage: "linear-gradient(to top, ".concat(UI.COLORS[shadowColor], " 20%, rgba(255, 255, 255, 0) 100%)"),
        transform: "translateY(".concat(shadowHeight + shadowOffset, "px)"),
        zIndex: 10
      };
      return React.createElement("div", {
        style: containerStyle,
        className: className
      }, withShadow && scrollHeight > clientHeight && shadowOffset !== -shadowHeight && React.createElement("div", {
        style: shadowTopStyle
      }), withShadow && scrollHeight > clientHeight && shadowOffset < 0 && React.createElement("div", {
        style: shadowBottomStyle
      }), React.createElement(Scrollbars, _extends({
        renderTrackVertical: function renderTrackVertical(nodeProps) {
          return _this2.renderTrack(_objectSpread({}, nodeProps), 'vertical');
        },
        renderTrackHorizontal: function renderTrackHorizontal(nodeProps) {
          return _this2.renderTrack(_objectSpread({}, nodeProps), 'horizontal');
        },
        renderThumbHorizontal: this.renderThumb,
        renderThumbVertical: this.renderThumb,
        onUpdate: this.handleUpdate,
        hideTracksWhenNotNeeded: true
      }, props), React.createElement("div", {
        ref: function ref(node) {
          _this2.scrollable = node;
        }
      }, children)));
    }
  }]);

  return Scrollable;
}(PureComponent);

_defineProperty(Scrollable, "propTypes", {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,

  /**
   * Enable auto-hide mode
   * @see See [github docs](https://github.com/malte-wessel/react-custom-scrollbars/blob/master/docs/API.md) for description
   */
  autoHide: PropTypes.bool,

  /**
   * Hide delay in ms.
   */
  autoHideTimeout: PropTypes.number,

  /**
   * Duration for hide animation in ms.
   */
  autoHideDuration: PropTypes.number,

  /**
   * Enable auto-height mode.
   */
  autoHeight: PropTypes.bool,

  /**
   * Set a minimum height for auto-height mode
   */
  autoHeightMin: PropTypes.number,

  /**
   * Set a maximum height for auto-height mode
   */
  autoHeightMax: PropTypes.number,

  /**
   * Event handler
   */
  onScroll: PropTypes.func,

  /**
   * Runs inside the animation frame.
   */
  onScrollFrame: PropTypes.func,

  /**
   * Called when scrolling starts
   */
  onScrollStart: PropTypes.func,

  /**
   * Called when scrolling stops
   */
  onScrollStop: PropTypes.func,

  /**
   * Height of shadow
   */
  shadowHeight: PropTypes.number,

  /**
   * Show shadow in scrollable component
   */
  withShadow: PropTypes.bool,

  /**
   * Color of shadow from #Colors
   */
  shadowColor: PropTypes.oneOf(Object.keys(_objectSpread({}, UI.COLORS, UI.THEME_COLORS))),

  /**
   * Opacity of shadow
   */
  shadowOpacity: PropTypes.number,

  /**
   * Color of thumb
   */
  thumbColor: PropTypes.oneOf(Object.keys(_objectSpread({}, UI.COLORS, UI.THEME_COLORS))),

  /**
   * Opacity of thumb
   */
  thumbOpacity: PropTypes.number,

  /**
   * Border radius of thumb (px)
   */
  thumbBorderRadius: PropTypes.number,

  /**
  /**
   * Border radius of thumb (px)
   */
  thumbWidth: PropTypes.number,

  /**
   * Color of track (HEX)
   */
  trackColor: PropTypes.string,

  /**
   * Opacity of track
   */
  trackOpacity: PropTypes.number,

  /**
   * Border radius of track (px)
   */
  trackBorderRadius: PropTypes.number,

  /**
  /**
   * Border radius of track (px)
   */
  trackWidth: PropTypes.number,

  /**
   * Style for scrollable container
   */
  style: PropTypes.object,

  /**
   * Classname of scrollable container
   */
  className: PropTypes.string,

  /**
   * Disable scrollbar and return div
   */
  disabled: PropTypes.bool,

  /**
   * Prevent body scrolling when start|end touched
   */
  isolate: PropTypes.bool
});

_defineProperty(Scrollable, "defaultProps", {
  autoHide: false,
  autoHideTimeout: 1000,
  autoHideDuration: 200,
  autoHeight: false,
  withShadow: false,
  shadowHeight: 50,
  shadowOpacity: 0.15,
  shadowColor: 'mineShaft',
  thumbColor: 'mineShaft',
  thumbOpacity: 0.15,
  thumbBorderRadius: 1,
  thumbWidth: 4,
  trackColor: '#333333',
  trackOpacity: 0.15,
  trackBorderRadius: 1,
  trackWidth: 4,
  disabled: false,
  isolate: true
});

export { Scrollable };